@if (isRedirecting()) {
  <app-loader [isFullscreen]="true" [showVersion]="false" />
}

<mat-toolbar class="header">
  <div class="header-left">
    <div class="pantera-lockup">
      <div class="pantera-icon-wrapper">
        <div class="negative-logo" matTooltip="{{ version }}" (click)="redirectIfAdmin()"></div>
        @if (isDev) {
          <span class="dev-badge" [matTooltip]="'MAP.DEV_ENVIRONMENT_TOOLTIP' | translate">
            {{ 'MAP.DEV_BADGE' | translate }}
          </span>
        }
      </div>
      <div class="pantera-lockup-text">
        <div class="pantera-wordmark negative-tipo"></div>
        @if (user.planLabel(); as plan) {
          <span class="pantera-tagline">{{ plan.key | translate }}{{ plan.suffix }}</span>
        }
      </div>
    </div>

    <!-- Nome cliente/planta pra user ugm -->
    @if (user?.isUgm() && routeGuards.authorized | async) {
      <button mat-button [matMenuTriggerFor]="ugmClientsMenu" (menuOpened)="focusOnSearch()">
        <div class="user-info">
          <span class="user-info-name">{{ displayedClientePlantaName() }}</span>
          <span class="user-info-planta-id">({{ user.getIdPlanta() }})</span>
        </div>
        <mat-icon class="arrow-icon">arrow_drop_down</mat-icon>
      </button>
      @if (user.tipoRelacionamento()) {
        <span
          class="relationship-badge"
          [style.background-color]="user.tipoRelacionamento()?.cores?.color"
          [style.color]="user.tipoRelacionamento()?.cores?.textColor"
        ></span>
      }
    }

    <!-- Nome cliente/planta pra user não ugm -->
    @if (!user.isUgm() && routeGuards.authorized | async) {
      <div class="client-name">
        <div class="user-info">
          {{ displayedClientePlantaName() }}
        </div>
      </div>
    }

    <!-- Menu de clientes/plantas pra user ugm -->
    <mat-menu #ugmClientsMenu="matMenu" class="plant-select-menu">
      <div class="plant-search-container" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="search-form">
          <mat-icon matPrefix>search</mat-icon>
          <input
            matInput
            type="text"
            placeholder="Buscar cliente ou planta..."
            [(ngModel)]="searchFilterUgm"
            autocomplete="off"
            #searchInput
          />
          @if (searchFilterUgm) {
            <button matSuffix mat-icon-button (click)="clearSearchUgm()" type="button">
              <mat-icon>close</mat-icon>
            </button>
          }
        </mat-form-field>
      </div>
      @for (client of getFilteredClientMenu(); let i = $index; track client.key) {
        @if (client.value.length === 1) {
          <!-- Apenas uma planta -->
          <button
            mat-menu-item
            (click)="changePlanta(client.value[0])"
            [ngClass]="this.user.getIdPlanta() === client.value[0].id_planta ? 'planta-selected' : ''"
          >
            @if (this.user.getIdPlanta() === client.value[0].id_planta) {
              <mat-icon>check_small</mat-icon>
            }
            <div class="fx-row-space-between-center">
              <span class="menu-item-name-group">
                @if (searchFilterUgm && client.value[0].nome_cliente !== client.value[0].nome_planta) {
                  {{ client.value[0].nome_cliente }} - {{ client.value[0].nome_planta }}
                } @else {
                  {{ client.value[0].nome_cliente }}
                }
                @if (client.value[0].id_tipo_relacionamento != null) {
                  <span
                    class="relationship-badge"
                    [style.background-color]="getRelacionamentoCores(client.value[0].id_tipo_relacionamento).color"
                    [style.color]="getRelacionamentoCores(client.value[0].id_tipo_relacionamento).textColor"
                  ></span>
                }
              </span>
              <span>{{ client.value[0].id_planta }}</span>
            </div>
          </button>
        } @else {
          <!-- Mais de uma planta com submenu -->
          <button
            mat-menu-item
            [matMenuTriggerFor]="clientSubMenu"
            [ngClass]="isClientSelected(client.value) ? 'planta-selected' : ''"
          >
            {{ client.key }}
          </button>
          <mat-menu #clientSubMenu="matMenu" class="menu">
            @for (planta of client.value; track planta.id_planta) {
              <button
                mat-menu-item
                (click)="changePlanta(planta)"
                [ngClass]="this.user.getIdPlanta() === planta.id_planta ? 'planta-selected' : ''"
              >
                @if (this.user.getIdPlanta() === planta.id_planta) {
                  <mat-icon>check_small</mat-icon>
                }
                <div class="fx-row-space-between-center">
                  <span class="menu-item-name-group">
                    {{ planta.nome_planta }}
                    @if (planta.id_tipo_relacionamento != null) {
                      <span
                        class="relationship-badge"
                        [style.background-color]="getRelacionamentoCores(planta.id_tipo_relacionamento).color"
                        [style.color]="getRelacionamentoCores(planta.id_tipo_relacionamento).textColor"
                      ></span>
                    }
                  </span>
                  <span>{{ planta.id_planta }}</span>
                </div>
              </button>
            }
          </mat-menu>
        }
      }
      @if (getFilteredClientMenu().length === 0 && searchFilterUgm) {
        <div style="padding: 16px; text-align: center; color: rgba(255, 255, 255, 0.6)">Nenhuma planta encontrada</div>
      }
    </mat-menu>

    <!-- Menu de plantas pra gestor nível 2 -->
    @if (user?.isManager2() || user?.isOperatorReadOnly()) {
      <button mat-button [matMenuTriggerFor]="clientPlantasMenu">
        <span class="user-info">
          {{ user.getNomePlanta() }}
        </span>
        <mat-icon class="arrow-icon">arrow_drop_down</mat-icon>
      </button>
    }
    <mat-menu #clientPlantasMenu="matMenu">
      @for (p of user.plantas_list; track p.nome_planta) {
        <button
          mat-menu-item
          (click)="changePlanta(p)"
          [ngClass]="this.user.getIdPlanta() === p.id_planta ? 'planta-selected' : ''"
        >
          <span [ngClass]="user.darkMode() ? 'user-info-dark' : ''">
            {{ p.nome_planta }}
          </span>
        </button>
      }
    </mat-menu>
  </div>
  <div class="header-right">
    <div class="client-logo-container">
      <img class="client-logo" [src]="user.logoUrlSubject | async" (error)="handleImageError($event)" />
    </div>

    <div class="user-actions-hub">
      <!-- Sino de notificações comentado para a próxima PR
      <button mat-icon-button matTooltip="Notificações">
        <mat-icon>notifications</mat-icon>
      </button>
      -->
      @if (user.isSupportEdge()) {
        <button
          mat-icon-button
          disableRipple
          matTooltipPosition="above"
          matTooltip="{{ 'MAP.OPEN_INTERFACE' | translate }}"
          (click)="openInterface()"
          class="unselected-panel-btn"
        >
          <mat-icon>network_intelligence</mat-icon>
        </button>
      }
      @if (showUsersButton()) {
        <button
          mat-icon-button
          disableRipple
          matTooltipPosition="above"
          matTooltip="{{ 'MAP.USERS' | translate }}"
          (click)="openUsers()"
          [ngClass]="user.activePanel() === 'users' ? 'selected-panel-btn' : 'unselected-panel-btn'"
        >
          <mat-icon>group</mat-icon>
        </button>
      }
      <button
        mat-icon-button
        disableRipple
        matTooltipPosition="above"
        matTooltip="{{ 'MAP.MY_ACCOUNT' | translate }}"
        (click)="openSettings()"
        [ngClass]="user.activePanel() === 'settings' ? 'selected-panel-btn' : 'unselected-panel-btn'"
      >
        <mat-icon
          [matBadge]="user.isPanteraMessageVisibleToUser() ? '!' : ''"
          matBadgeColor="warn"
          [matBadgeHidden]="!user.isPanteraMessageVisibleToUser()"
          matBadgeSize="small"
        >
          account_circle
        </mat-icon>
      </button>
    </div>
  </div>
</mat-toolbar>
